export const Tech_Team = [
    {
        img: require('../assets/org1.jpg'),
        name: 'Mohd Tauheed',
        role: 'Web developer',
        society: 'GDSC JMI'
    },
    {
        img: require('../assets/org2.jpg'),
        name: 'Hiba khan',
        role: 'Operations Team',
        society: 'GDSC JMI'
    },
    {
        img: require('../assets/org3.jpg'),
        name: 'Asif Rehman',
        role: 'Tech Secretary',
        society: 'SoarX JMI'
    },
    {
        img: require('../assets/org4.jpg'),
        name: 'Nitin Chaudhary',
        role: 'Web developer',
        society: 'SoarX JMI',
    },
    {
        img: require('../assets/org8.jpg'),
        name: 'Filza Siddiqui',
        role: 'Web developer',
        society: 'GDSC JMI'
    }
]

export const Organiser = [

    {
        img: require('../assets/org6.jpg'),
        name: 'Insharah Ayyubi',
        role: 'Lead',
        society: 'GDSC JMI'
    },
    {
        img: require('../assets/org5.jpg'),
        name: 'Ali Nasir',
        role: 'President and Founder',
        society: 'SoarX JMI'
    },
    {
        img: require('../assets/org7.jpg'),
        name: 'Zaid Khan',
        role: 'Operations Lead',
        society: 'GDSC JMI'
    },
]